import { createAction, createAsyncAction } from 'typesafe-actions';

import type { OfferRule, ProductType } from '@evenfinancial/originator-client';
import type { SupplyDemandInclusion } from '@evenfinancial/partner-data-client';

import type { DemandEnablement } from '@portal/ui-lib';

import type {
  CreateSupplyTemplateApplicationPayload,
  DemandEnablementDeletePayload,
  DemandEnablementRequestPayload,
  DemandEnablementUpdatePayload,
} from '../types';

import { DemandInclusionActionType } from './actionTypes';

// typesafe-actions 6.0+ supports withTypes which allows you to pass in meta fields but it is still in beta. Doing it manually here
export const applyDemandInclusionTemplateRequest = createAction(
  DemandInclusionActionType.APPLY_DEMAND_INCLUSION_TEMPLATE_REQUEST,
  (
    payload: CreateSupplyTemplateApplicationPayload,
    meta?: { onSuccess?: () => void }
  ) => ({
    meta,
    payload,
  })
)();

export const applyDemandInclusionTemplateSuccess = createAction(
  DemandInclusionActionType.APPLY_DEMAND_INCLUSION_TEMPLATE_SUCCESS
)<void>();

export const applyDemandInclusionTemplateFailure = createAction(
  DemandInclusionActionType.APPLY_DEMAND_INCLUSION_TEMPLATE_FAILURE
)<Error>();

export const applyDemandInclusionTemplateAction = {
  failure: applyDemandInclusionTemplateFailure,
  request: applyDemandInclusionTemplateRequest,
  success: applyDemandInclusionTemplateSuccess,
};

export const demandInclusionsRequestAction = createAsyncAction(
  DemandInclusionActionType.GET_DEMAND_INCLUSIONS_REQUEST,
  DemandInclusionActionType.GET_DEMAND_INCLUSIONS_SUCCESS,
  DemandInclusionActionType.GET_DEMAND_INCLUSIONS_FAILURE
)<DemandEnablementRequestPayload, SupplyDemandInclusion[], Error>();

export const demandInclusionsCreateBulkAction = createAsyncAction(
  DemandInclusionActionType.CREATE_BULK_DEMAND_INCLUSIONS_REQUEST,
  DemandInclusionActionType.CREATE_BULK_DEMAND_INCLUSIONS_SUCCESS,
  DemandInclusionActionType.CREATE_BULK_DEMAND_INCLUSIONS_FAILURE
)<DemandEnablementUpdatePayload[], SupplyDemandInclusion[], Error[]>();

export const demandInclusionsDeleteBulkAction = createAsyncAction(
  DemandInclusionActionType.DELETE_BULK_DEMAND_INCLUSIONS_REQUEST,
  DemandInclusionActionType.DELETE_BULK_DEMAND_INCLUSIONS_SUCCESS,
  DemandInclusionActionType.DELETE_BULK_DEMAND_INCLUSIONS_FAILURE
)<DemandEnablementDeletePayload[], number[], Error[]>();

export const demandEnablementsRequestAction = createAsyncAction(
  DemandInclusionActionType.GET_DEMAND_ENABLEMENTS_REQUEST,
  DemandInclusionActionType.GET_DEMAND_ENABLEMENTS_SUCCESS,
  DemandInclusionActionType.GET_DEMAND_ENABLEMENTS_FAILURE
)<{ productType: ProductType }, DemandEnablement, Error>();

export const getOfferRulesBySubaccountIdAction = createAsyncAction(
  DemandInclusionActionType.GET_OFFER_RULES_BY_SUBACCOUNT_ID_REQUEST,
  DemandInclusionActionType.GET_OFFER_RULES_BY_SUBACCOUNT_ID_SUCCESS,
  DemandInclusionActionType.GET_OFFER_RULES_BY_SUBACCOUNT_ID_FAILURE
)<{ supplySubAccountId: number }, OfferRule[], Error>();
